import { createContext, useContext } from 'react';

const SettingsContext = createContext<any>(undefined);

export const useSettingsContext = () => useContext(SettingsContext);
export default SettingsContext;
